import privilegesMutations from "./mutations.js";
import privilegesActions from "./actions.js";
import privilegesGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            allPrivileges: { Basic: [], DAM: [], Archive: [], Advanced: [], "AI Tools":[], "Media Pipeline":[] },
            enabledActions: []
        };
    },
    mutations: privilegesMutations,
    actions: privilegesActions,
    getters: privilegesGetters,
};